import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Environment } from '@docorga-v1/docorga-angular';
import { IEnvironmentConf } from '@environments/environment.interface';

@Pipe({ name: 'downloadPublic' })
export class DownloadPublicPipe implements PipeTransform {
  constructor(@Inject(Environment) private readonly environment: IEnvironmentConf) {}

  transform(fileName: string, containerName: string, kind: string): string {
    return `${this.environment.azureBlobUrl}/${containerName}/${kind}_${fileName}`;
  }
}
